export default __webpack_public_path__ + "static/media/ETL_process.74a0f224.png";